import React, { useMemo, useState, useRef } from 'react';
// import { Navbar, NavbarBrand } from 'reactstrap';
import './index.scss';
import pwslogo from '../../assets/images/pws-logo3.png';
import emrlogo from "../../assets/images/emerson-logo.png";
//import {BiUserCircle} from "react-icons/bi"; 
import { useDispatch, useSelector } from "react-redux";
// import { useOktaAuth } from '@okta/okta-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setProfile } from "../redux/profile/profileActions";
import ShowTags from '../tags';
import Profile from '../profile';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import toastr from 'toastr';
import { regionLang, region } from '../translation/regionVal';
import { useTranslation } from 'react-i18next';
import { destroyGrid } from '../redux/ctrl/ctrlActions';
import { fPkgsUpdtStsAct } from '../redux/project/projActions';

import { MdNotificationsNone } from "react-icons/md";
import { Badge, Chip, Divider, IconButton, List, ListItem, ListItemText, Popover, Typography } from "@mui/material";

import config from "../../utils/config";
import COLORS from '../styles/COLORS';
import { useAuth0 } from '@auth0/auth0-react';
import { getUnreadNotification, updateNotification } from '../redux/app/appActions';


const NavBar = ({ setCorsErrorModalOpen }) => {
  const { getIdTokenClaims } = useAuth0();
  const navigate = useNavigate();
  // const { authState, oktaAuth } = useOktaAuth();
  const dispatch = useDispatch();
  const profileState = useSelector((state) => state.profile);
  const ctrlState = useSelector((state) => state.ctrl);
  const [tokenActive, setTokenActive] = useState(false);
  const projStat = useSelector((state) => state.ctrl.projStatus);
  const ctrl = useSelector((state) => state.ctrl);
  const { pathname } = useLocation();
  const isImpactPartnerRoute = useMemo(
    () => pathname.startsWith('/punchout'),
    [pathname]
  )


  const { t, i18n } = useTranslation();
  const [curCountry, setCurCountry] = useState('');
  const [curLang, setCurLang] = useState('');
  const [curLangName, setCurLangName] = useState('');

  const [langModal, setLangModal] = useState(false);
  const [langValue, setlangValue] = useState([]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [socket, setSocket] = useState(null);
  const [socketClosed, setSocketClosed] = useState(false);
  const [notifyCount, setNotifyCount] = useState(null);
  const [receivedMessage, setReceivedMessage] = useState([]);
  const [unReadNotification, setUnReadNotification] = useState([]);
  const [data, setDataUrl1] = useState({});
  const unreadNotifications = useSelector((state) => state.app.unreadNotifications)

  const projectState = useSelector((state) => state.project)
  const reconnectAttempts = useRef(0);
  const maxReconnectAttempts = 20;
  // const history = useHistory();
  const isCorsError = (err) => (err.name === 'AuthApiError' && !err.errorCode && err.xhr.message === 'Failed to fetch');
  // const logout = async () => {

  //   // const basename = window.location.origin + history.createHref({ pathname: '/' });
  //   const basename = window.location.origin + '/'
  //   try {
  //     await oktaAuth.revokeAccessToken().catch((err) => {
  //       // console.log(err);
  //     });
  //     //await oktaAuth._oktaUserAgentsignOut({ revokeAccessToken: true })
  //     await oktaAuth.signOut({ postLogoutRedirectUri: basename });
  //     localStorage.removeItem('okta-original-uri-storage')
  //     localStorage.removeItem('okta-cache-storage')
  //     localStorage.removeItem('okta-shared-transaction-storage')
  //     localStorage.removeItem('okta-token-storage')
  //     localStorage.removeItem('loggedIn')
  //     localStorage.clear();
  //     await oktaAuth.signOut({ postLogoutRedirectUri: basename });

  //     // dispatch(setProfile({email:"",
  //     //   family_name:"",
  //     //   given_name:"",
  //     //   name:""}));

  //   } catch (err) {
  //     if (isCorsError(err)) {
  //       setCorsErrorModalOpen(true);
  //     } else {
  //       throw err;
  //     }
  //   }
  // };

  // const logoutRefresh = () => {
  //   console.log("Refresh Call..")
  //   logout();
  //   setTimeout(() => {
  //     navigate("/")
  //     window.location.reload(true);
  //   }, 4000)
  // }

  async function wsConnectHandler() {

    // let jwtAuth = ""
    // let Authtoken = JSON.parse(localStorage.getItem('okta-token-storage'))?.idToken?.idToken
    // if (Authtoken) {
    //   jwtAuth = `${Authtoken}`
    // } else {
    //   return
    // }
    //const ws = new WebSocket(...webConfig);
    //ws = new WebSocket("ws://localhost:3000/ws?token=" + jwtAuth);
    const WSURL = config.PGAPI_URL

    // const ws = io({
    //   path: 'ws://localhost:8000/ws/' + profileState.email + '?token=' + jwtAuth,
    //   reconnection: true,
    //   autoConnect: true
    // });
    const idClaims = await getIdTokenClaims();
    const idToken = idClaims?.__raw || "";
    // const ws = new WebSocket(WSURL + '/ws/' + profileState.email + '?token=' + jwtAuth);
    const ws = new WebSocket(WSURL + '/ws/' + profileState.email + '?token=' + idToken + '&token_type=auth0');

    // Connection opened
    ws.onopen = () => {
      console.log('WebSocket connection opened');
      setSocket(ws)
      setSocketClosed(false)
    };

    // Listen for messages
    ws.onmessage = (event) => {
      console.log(event)
      //toastr.success(event.data);

      const data = JSON.parse(event.data);

      setReceivedMessage(prev => [...prev, ...data].filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id === value.id && t.is_notification_read === value.is_notification_read
        ))
      ).sort((a, b) => b.id - a.id));
      if (data.length > 0 && ["BULK_UPDATE_PKG_PRICE", "BULK_TAG_SIZING"].includes(data[0].type)) {
        dispatch(fPkgsUpdtStsAct({ project_id: data[0].project_id, package_id: data[0].package_id, in_progress: data[0].data.pkg_inprocess }))
      }
    };

    // Handle errors
    ws.onerror = (error) => {
      console.error('WebSocket error', error);
      setSocket(null)
    };

    // Connection closed
    ws.onclose = () => {
      console.log('WebSocket connection closed');
      setSocketClosed(true)
      setSocket(null)
      setTimeout(() => {
        console.log('Attempting to reconnect...');
        //wsConnectHandler();  //temp commented
      }, 5000);
    };

  }

  async function reconnectWs() {
    if (reconnectAttempts.current >= maxReconnectAttempts) {
      console.log('Max reconnect attempts reached');
      toastr.warning('Notification connection lost. Please refresh the page to reconnect.');
      return;
    }
    const delay = Math.min(1000 * Math.pow(2, reconnectAttempts.current), 30000);
    reconnectAttempts.current += 1;
    console.log(`Reconnecting in ${delay / 1000}s (attempt ${reconnectAttempts.current})`);
    setTimeout(async () => {
      try {
        console.log('Reconnect attempt...');
        const freshData = await fetchPbSbUrl();
        if (freshData?.url) {
          wsConnectHandlerPS(freshData.url);
        }
      } catch (err) {
        console.error('Reconnect negotiate failed:', err);
        // reconnectWs();
      }
    }, delay);
  }

  async function fetchPbSbUrl() {
    const idClaims = await getIdTokenClaims();
    const idToken = idClaims?.__raw || "";

    const clientId = profileState.email //.replace(/[@.]/g, '_');
    const response = await fetch(`${config.PGAPI_URL}/negotiate/${clientId}`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    const data = await response.json();
    return data;
  }

  function wsConnectHandlerPS(url) {

    // let jwtAuth = ""
    // let Authtoken = JSON.parse(localStorage.getItem('okta-token-storage'))?.idToken?.idToken
    // if (Authtoken) {
    //   jwtAuth = `${Authtoken}`
    // } else {
    //   return
    // }
    //const ws = new WebSocket(...webConfig);
    //ws = new WebSocket("ws://localhost:3000/ws?token=" + jwtAuth);

    // const ws = io({
    //   path: 'ws://localhost:8000/ws/' + profileState.email + '?token=' + jwtAuth,
    //   reconnection: true,
    //   autoConnect: true
    // });
    if (!url) return;
    const socket = new WebSocket(url, 'json.webpubsub.azure.v1');
    // Connection opened
    socket.onopen = () => {
      console.log('WebSocket connection opened');
      reconnectAttempts.current = 0;
      setSocketClosed(false)
      setSocket(socket)
      dispatch(getUnreadNotification(profileState.email))
    };

    // Listen for messages
    socket.onmessage = (event) => {
      console.log(event)
      //toastr.success(event.data);

      const eData = JSON.parse(event?.data)
      if (typeof eData?.data !== "string") {
        return
      }
      const data = JSON.parse(eData?.data);





      setReceivedMessage(prev => [...prev, ...data].filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id === value.id && t.is_notification_read === value.is_notification_read
        ))
      ).sort((a, b) => b.id - a.id));
      if (data.length > 0 && ["BULK_UPDATE_PKG_PRICE", "BULK_TAG_SIZING"].includes(data[0].type)) {
        dispatch(fPkgsUpdtStsAct({ project_id: data[0].project_id, package_id: data[0].package_id, in_progress: data[0].data.pkg_inprocess }))
      }
    };

    // Handle errors
    socket.onerror = (error) => {
      console.error('WebSocket error', error);
      // setSocket(null)
    };

    // Connection closed
    socket.onclose = () => {
      console.log('WebSocket connection closed');
      setSocketClosed(true)
      // setSocket(null)

      setTimeout(() => {
        console.log('Attempting to reconnect...');
        // wsConnectHandler();
        reconnectWs();
        // wsConnectHandlerPS(data.url)
        // setSocket(null)
      }, 5000);
    };

  }

  useEffect(() => {
    // Create WebSocket connection.
    console.log("socket:", socket)
    if (profileState.email && !socket) {
      // wsConnectHandler()
      console.log('WebSocket connection restart');
      fetchPbSbUrl().then((res) => {
        console.log(res)
        setDataUrl1(res)
      }
      ).catch((err) => {
        console.log(err)
      })
    }

    // Clean up on component unmount
    // return () => {

    //   if (socket && socketClosed) {
    //     socket.close();
    //     //setSocket(null)
    //     console.log("Kill WS SESSION")
    //   }
    // };
  }, [profileState.email, socket]);

  useEffect(() => {
    console.log("Data URL ", data?.url)
    if (!data?.url) return;
    wsConnectHandlerPS(data.url)
  }, [data?.url])

  // useEffect(() => {
  //   if (socketClosed && !socket) {
  //     console.log('WebSocket connection restart');
  //     // wsConnectHandler()
  //     wsConnectHandlerPS(data.url) //temp commented
  //   }
  // }, [socketClosed, socket])

  const sendMessage = (payload) => {

    // if (socket && !socketClosed && (unReadNotification.length > 0 && unReadNotification.length != null)) {
    //   console.log('Sending message:', unReadNotification);
    //   socket.send(JSON.stringify(unReadNotification));
    // }
    // console.log('Sending message:', unReadNotification);
    // dispatch(updateNotification([{ "msg": "unReadNotification" }]))
    if (unReadNotification.length > 0 && unReadNotification.length != null) {
      console.log('Sending message:', unReadNotification);
      dispatch(updateNotification(unReadNotification))
    }
  };

  useEffect(() => {
    // if (receivedMessage.length === 0) return;
    const unReadNotification = receivedMessage?.filter((item) => item['is_notification_read'] === false)
    console.log("receivedMessage ", receivedMessage)
    console.log("unReadNotification ", unReadNotification)
    setUnReadNotification(unReadNotification)
    setNotifyCount(unReadNotification.length)
  }, [receivedMessage])


  // useEffect(() => {
  //   if (projectState?.expiredLogout) {
  //     logoutRefresh();
  //   }
  // }, [projectState?.expiredLogout])
  useEffect(() => {
    if (unreadNotifications.length === 0) return;
    setReceivedMessage(prev => [...prev, ...unreadNotifications])
  }, [unreadNotifications])

  // useEffect(() => {
  //   if (projectState?.expiredLogout) {
  //     logoutRefresh();
  //   }
  // }, [projectState?.expiredLogout])

  useEffect(() => {
    if (regionLang[curCountry] && curCountry) {
      setlangValue(regionLang[curCountry]);
      setCurLang('');
    }
  }, [curCountry])

  // useEffect(() => {
  // let Authtoken = JSON.parse(localStorage.getItem('okta-token-storage'))?.idToken?.idToken;
  // if (Authtoken && !tokenActive) {
  //   setTokenActive(true);
  // }
  // if (ctrlState.refresh && tokenActive) {
  //   logoutRefresh();
  // }

  // window.addEventListener("storage", () => {
  //   let Authtoken = JSON.parse(localStorage.getItem('okta-token-storage'))?.idToken?.idToken;
  //   if (!Authtoken) {
  //     logoutRefresh();
  //   }
  // });

  // }, [ctrlState.refresh])


  // if (!authState) {
  //   return null;
  // }

  const changeLang = () => {
    setLangModal(true);
  }
  const changeLangClose = () => {
    setLangModal(false); setCurLang(''); setCurCountry('');
  }
  // const handleChangeCon = (v) =>{
  // setCurCountry(v.target.value); 
  // }
  const handleChangeCon = (event, newValue) => {
    if (newValue) {
      setCurCountry(newValue.value);
    } else {
      setCurCountry('');
    }
  };

  const handleChangeLang = (v) => {
    if (v) {
      setCurLang(v.value);
      setCurLangName(v.label);
    } else {
      setCurLang('');
      setCurLangName('');
    }
  };

  const selectLang = () => {
    let langAdd = curLang;
    if (!curCountry) {
      toastr.error("Please select Country");
    }
    if (curCountry && !curLang) {
      toastr.error("Please select Language");
    }
    let findLangName = langValue.filter((lang) => lang.value === curLang);

    if (curLang === localStorage.getItem("lang")) {
      toastr.error("Language is already " + findLangName[0]?.label);
    }

    if (curCountry && curLang && curLang !== localStorage.getItem("lang")) {
      i18n.changeLanguage(langAdd);

      // projStat.map((stat, i)=>{  
      //   projStat[i].label = t(stat.en);
      // })

      // ctrl.pkgStatus.map((stat, i)=>{  
      //   ctrl.pkgStatus[i].label = t(stat.en);
      // })
      //     ctrl.currencies.map((stat, i)=>{  
      //       ctrl.currencies[i].label = t(stat.en);
      //     })
      //     ctrl.pricingRegion.map((stat, i)=>{
      //       ctrl.pricingRegion[i].label = t(stat.en);
      //   })
      //   ctrl.tagStatus.map((stat, i)=>{
      //     ctrl.tagStatus[i].label = t(stat.en);
      // })

      ctrl.labeltoDisplay = t(ctrl.labeltoDisplayNew.en);
      localStorage.setItem("lang", langAdd);
      dispatch(destroyGrid(true));
      setTimeout(() => dispatch(destroyGrid(false)));
      changeLangClose();
    }
  }

  //--- ws notification satrt
  function notificationsLabel(count) {
    if (count === 0) {
      return 'no notifications';
    }
    if (count > 99) {
      return 'more than 99 notifications';
    }
    return `${count} notifications`;
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    //test()
    // sendMessage("openedNotification")
    if (receivedMessage.length !== 0) {
      const openedNotification = receivedMessage.map((item) => ({ ...item, 'is_notification_read': true }))
      setReceivedMessage(openedNotification)
      sendMessage(openedNotification)
    }
    setAnchorEl(null);
  };


  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const clearNotificationHandler = () => {
    handleClose()
    setReceivedMessage([])
    setUnReadNotification([])
  }
  const bulkUpdatePkgPriceNotificationcomp = (item) => {
    return <React.Fragment key={item.id}>
      <ListItem
        sx={{
          backgroundColor: item.is_notification_read === false ? '#f1f1f1' : '#ffffff', margin: "0px 0px 4px 0px"
        }}

      >

        <ListItemText className='text-noto'
          primary={<>
            <span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Package : </span>
            <Typography
              className='text-noto'
              component="span"
              variant="body2"
              sx={{ display: 'inline', fontSize: '14px', fontWeight: 'bold', color: COLORS.green }}
            >{" " + item.package_name}
            </Typography><span style={{ color: COLORS.blue }}>&nbsp;|&nbsp;</span><span style={{ color: COLORS.green }}>Update Package Price </span>
          </>}
          sx={{ color: COLORS.blue, margin: 0, }}
          secondary={<>

            <Typography
              component="span"
              variant="body2"
              sx={{ margin: '5px 0 0 0', display: 'inline', fontSize: '12px', display: "flex", }}
            >
              {/* <span style={{ margin: '5px 0 0 0', fontWeight: 'bold' }}><span style={{ fontSize: '12px', color: 'black', }}>Batch Id: </span> <span style={{ color: '#00aa7e', fontSize: '12px', fontWeight: 'bold' }}>{item.batch_id} </span></span> */}
              <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: '50%', color: COLORS.blue, fontSize: '12px' }}><span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Project : </span><span style={{ color: COLORS.green, fontWeight: 'bold' }}>{item.project_name} </span> </span>
              <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: '50%', color: COLORS.blue, fontSize: '12px' }}><span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Package : </span><span style={{ color: COLORS.green, fontWeight: 'bold' }}>{item.package_name} </span> </span>

            </Typography>

            <span style={{ display: 'block', margin: '5px 0 0 0', fontSize: '13px', color: '#000000' }} >{
              <span> {item?.data?.message} </span>

            }</span>
          </>}
        />
      </ListItem>

      <Divider component="li" />
    </React.Fragment>
  }
  const bulkSizingNotificationcomp = (item) => {
    return <React.Fragment key={item.id}>
      <ListItem
        sx={{
          backgroundColor: item.is_notification_read === false ? '#f1f1f1' : '#ffffff', margin: "0px 0px 4px 0px"
        }}

      >

        <ListItemText className='text-noto'
          primary={<>
            <span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Package : </span>
            <Typography
              className='text-noto'
              component="span"
              variant="body2"
              sx={{ display: 'inline', fontSize: '14px', fontWeight: 'bold', color: COLORS.green }}
            >{" " + item.package_name}
            </Typography><span style={{ color: COLORS.blue }}>&nbsp;|&nbsp;</span><span style={{ color: COLORS.green }}>Copied Package Tags Sizing Completed</span>
          </>}
          sx={{ color: COLORS.blue, margin: 0, }}
          secondary={<>

            <Typography
              component="span"
              variant="body2"
              sx={{ margin: '5px 0 0 0', display: 'inline', fontSize: '12px', display: "flex", }}
            >
              {/* <span style={{ margin: '5px 0 0 0', fontWeight: 'bold' }}><span style={{ fontSize: '12px', color: 'black', }}>Batch Id: </span> <span style={{ color: '#00aa7e', fontSize: '12px', fontWeight: 'bold' }}>{item.batch_id} </span></span> */}
              <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: '50%', color: COLORS.blue, fontSize: '12px' }}><span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Project : </span><span style={{ color: COLORS.green, fontWeight: 'bold' }}>{item.project_name} </span> </span>
              <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: '50%', color: COLORS.blue, fontSize: '12px' }}><span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Package : </span><span style={{ color: COLORS.green, fontWeight: 'bold' }}>{item.package_name} </span> </span>

            </Typography>

            <span style={{ display: 'block', margin: '5px 0 0 0', fontSize: '13px', color: '#000000' }} >{
              <span> {item?.data?.message} <span style={{ color: COLORS.blue, }}>|</span> Bulk Configuration is In-Process</span>

            }</span>
          </>}
        />
      </ListItem>

      <Divider component="li" />
    </React.Fragment>
  }


  const bulkConfigNotificationcomp = (item) => {
    return <React.Fragment key={item.id}>
      <ListItem
        sx={{
          backgroundColor: item.is_notification_read === false ? '#f1f1f1' : '#ffffff', margin: "0px 0px 4px 0px"
        }}

      >

        <ListItemText className='text-noto'
          primary={<>
            <span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Batch Id: </span>
            <Typography
              className='text-noto'
              component="span"
              variant="body2"
              sx={{ display: 'inline', fontSize: '14px', fontWeight: 'bold' }}
            >{" " + item.batch_id}
            </Typography><span style={{ color: COLORS.blue, }}>&nbsp;|&nbsp;</span><span style={{ color: COLORS.green }}>Bulk Configuration Completed</span>
          </>}
          sx={{ color: COLORS.green, margin: 0, }}
          secondary={<>

            <Typography
              component="span"
              variant="body2"
              sx={{ margin: '5px 0 0 0', display: 'inline', fontSize: '12px', display: "flex", }}
            >
              {/* <span style={{ margin: '5px 0 0 0', fontWeight: 'bold' }}><span style={{ fontSize: '12px', color: 'black', }}>Batch Id: </span> <span style={{ color: '#00aa7e', fontSize: '12px', fontWeight: 'bold' }}>{item.batch_id} </span></span> */}
              <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: '50%', color: COLORS.blue, fontSize: '12px' }}><span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Project : </span><span style={{ color: COLORS.green, fontWeight: 'bold' }}>{item.project_name} </span> </span>
              <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: '50%', color: COLORS.blue, fontSize: '12px' }}><span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Package : </span><span style={{ color: COLORS.green, fontWeight: 'bold' }}>{item.package_name} </span> </span>

            </Typography>

            <span style={{ display: 'block', margin: '5px 0 0 0', fontSize: '13px', }} >{
              <span>Success: {item?.data?.countSuccess} , Cancel: {item?.data?.countCancel} , Fail: {item?.data?.countFail} , Total: {item?.data?.countTotal}</span>

            }</span>
          </>}
        />
      </ListItem>

      <Divider component="li" />
    </React.Fragment>
  }
  const bulkPriceItemNotificationcomp = (item) => {
    return <React.Fragment key={item.id}>
      <ListItem
        sx={{
          backgroundColor: item.is_notification_read === false ? '#f1f1f1' : '#ffffff', margin: "0px 0px 4px 0px"
        }}

      >

        <ListItemText className='text-noto'
          primary={<>
            <span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Batch Id: </span>
            <Typography
              className='text-noto'
              component="span"
              variant="body2"
              sx={{ display: 'inline', fontSize: '14px', fontWeight: 'bold' }}
            >{" " + item.batch_id}
            </Typography><span style={{ color: COLORS.blue }}>&nbsp;|&nbsp;</span><span style={{ color: COLORS.green }}>Price Part Completed</span>
          </>}
          sx={{ color: COLORS.green, margin: 0, }}
          secondary={<>

            <Typography
              component="span"
              variant="body2"
              sx={{ margin: '5px 0 0 0', display: 'inline', fontSize: '12px', display: "flex", }}
            >
              {/* <span style={{ margin: '5px 0 0 0', fontWeight: 'bold' }}><span style={{ fontSize: '12px', color: 'black', }}>Batch Id: </span> <span style={{ color: '#00aa7e', fontSize: '12px', fontWeight: 'bold' }}>{item.batch_id} </span></span> */}
              <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: '50%', color: COLORS.blue, fontSize: '12px' }}><span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Project : </span><span style={{ color: COLORS.green, fontWeight: 'bold' }}>{item.project_name} </span> </span>
              <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: '50%', color: COLORS.blue, fontSize: '12px' }}><span style={{ fontWeight: 'bold', color: COLORS.blue, }}>Package : </span><span style={{ color: COLORS.green, fontWeight: 'bold' }}>{item.package_name} </span> </span>

            </Typography>

            <span style={{ display: 'block', margin: '5px 0 0 0', fontSize: '13px', }} >{
              <span>Success: {item?.data?.countSuccess} , Fail: {item?.data?.countFail} , Total: {item?.data?.countTotal}</span>

            }</span>
          </>}
        />
      </ListItem>

      <Divider component="li" />
    </React.Fragment>
  }

  //---- ws notification end

  return (
    <>

      {/* <div className='info-message'>
        <b>🚨 Notice: FY26 Price Lists Setup </b>
On October 1st, the FY26 Price Lists will undergo setup and validation. Please await official confirmation before utilizing them. Thank you for your cooperation.
      </div> */}

      {/* <div className='info-message'>
        <b>✅ Update: FY26 Price Lists Approved </b>
The FY26 Price Lists have been successfully validated and are now ready for use. You may proceed with incorporating them into your packages and configuring Tags accordingly.
      </div> */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: { width: '40%' },
        }}
      >
        <div style={{ height: "auto", padding: "6px 0px 0px", margin: "0px 5px", display: "flex", justifyContent: "space-between", alignItems: "center" }} ><p style={{

          display: "inline",
          fontWeight: "Bold",
          color: COLORS.blue,
          fontSize: "16px",
          margin: "0px",
          padding: "0px 0px",
          display: "flex",
        }}>Notifications</p>{receivedMessage.length > 0 && <Button
          className='text-noto'
          onClick={clearNotificationHandler}
          size="small"
          sx={{ fontSize: "12px", color: COLORS.blue, height: "20px", padding: "0px", minWidth: "auto" }}
        >Clear All </Button>}
        </div>
        <div
        //        style={{ 
        //   width: '300px', 
        //   height: '200px'
        // }}
        >



          <List
            className='notificationList'
            dense
            sx={{
              //width: '100%',
              position: 'relative',
              overflow: 'auto',
              maxHeight: "600px",
              minHeight: "80px",
              '& ul': { padding: 0 },
            }} >

            {receivedMessage.length > 0 ? receivedMessage?.map((item) => {
              if (item.type == "BULK_TAG_SIZING") return bulkSizingNotificationcomp(item)
              if (item.type == "BULK_TAG_CONFIG") return bulkConfigNotificationcomp(item)
              if (item.type == "BULK_PRICE_ITEM") return bulkPriceItemNotificationcomp(item)
              if (item.type == "BULK_UPDATE_PKG_PRICE") return bulkUpdatePkgPriceNotificationcomp(item)
            }
            ) : <ListItem

              sx={{
                textAlign: "center"
              }}
            >
              <ListItemText secondary={"No Notification"} />
            </ListItem>}
          </List>

        </div>
      </Popover>
      <Grid container className="marginRow mainHeader" spacing={1.4}>

        {!isImpactPartnerRoute &&
          <Grid item md={3} sm={3} xs={3}>
            <div className='d-flex h-100'>
              <div className='headingMain my-auto'>
                <h1 className='m-0'>{t('MyProject Workspace')}</h1>
              </div>
            </div>
          </Grid>
        }

        <Grid sx={{ margin: 'auto' }} item md={6} sm={6} xs={6}>
          <div className='d-flex'>
            <div className='mx-auto'>
              <img className="d-inline-block align-top" style={{ marginTop: '5px' }} src={emrlogo} width="auto" height="45" alt="emerson-logo"></img>
            </div>
          </div>
        </Grid>

        {!isImpactPartnerRoute &&
          <Grid item md={3} sm={3} xs={3}>
            <Grid container className="marginRow" style={{ justifyContent: 'end' }} spacing={1.4}>
              {/* <Grid item md={7} sm={7} xs={7}>
            </Grid> */}
              <Grid item>
                <div className="navbar_notify_content">
                  <IconButton className={notifyCount > 0 ? 'has-notification' : ''} style={{ color: COLORS.green, fontSize: "30px" }} onClick={handleClick} aria-describedby={id} aria-label={notificationsLabel(notifyCount)}>
                    <Badge badgeContent={notifyCount} sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: COLORS.blue,
                        color: '#ffffff',
                        top: '3px',
                      }
                    }} >
                      <MdNotificationsNone />
                    </Badge>
                  </IconButton>
                </div>
                {/* <button onClick={sendMessage}>send</button> */}
              </Grid>


              <Grid item>
                <div className='d-flex'>
                  <div className='ml-auto d-flex'>
                    {/* <div className='app_lang d-flex'>
<span className='langCode'> {localStorage.getItem("lang") || "EN"} </span>
<span className='globalIcon my-auto ' onClick={changeLang}>
<RiGlobalLine title='Select Your Preferred Country & Language'  />
</span>  </div> */}
                    <div className='ml-auto d-flex header_profile'>
                      {/* <span className="my-auto prof font-black"> {profileState.givenName + ' ' + profileState.familyName} </span> */}
                      {/*<BiUserCircle className='settings'/>*/}
                      <Profile />
                    </div>

                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        }
      </Grid>
      {!ctrlState.showPkgs &&
        <>

          <AppBar position='static' className="mui-header">

            <Dialog open={langModal} onClose={changeLangClose} id="create-PRJ" className="create-project muiForm-Modal" aria-labelledby="draggable-dialog-title">
              <DialogTitle className="model-title mb-0" id="draggable-dialog-title"> Select a Country and Language </DialogTitle>
              <DialogContent style={{ "minHeight": '160px' }}>

                <Grid container className="marginRow muiForm mb-2 pt-3" spacing={1.4}>
                  <Grid item md={12} xs={12} className='mb-2'>
                    {/* <TextField
                                        select
                                        name="select_country"
                                        id="select_country"
                                        label={"Select a Country"}
                                        size='small'
                                        value={curCountry}
                                        onChange={handleChangeCon}
                                    >
                                        {region.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                              
                                    </TextField>   */}
                    <Autocomplete
                      id="select_country"
                      name="select_country"
                      size='small'
                      options={region}
                      getOptionLabel={(option) => option.label}
                      value={region.find(option => option.value === curCountry)}
                      onChange={handleChangeCon}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select a Country"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <Autocomplete
                      id="select_Lang"
                      name="select_Lang"
                      size='small'
                      options={langValue}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, newValue) => {
                        handleChangeLang(newValue);
                      }}
                      disabled={!curCountry}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select a Language"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>



                </Grid>



                <Grid container className="marginRow" spacing={1.4}>

                  <Grid item md={3} sm={3} xs={3}>
                    <div className='d-flex h-100'>
                      <div className='headingMain my-auto'>
                        <h1 className='m-0'>{t('MyProject Workspace')}</h1> </div>
                    </div>
                  </Grid>

                  <Grid item md={6} sm={6} xs={6}>
                    <div className='d-flex'>
                      <div className='mx-auto'>
                        <img className="d-inline-block align-top" src={emrlogo} width="auto" height="45" alt="emerson-logo"></img>
                      </div>
                    </div>
                  </Grid>



                  <Grid item md={3} sm={3} xs={3}>
                    <div className='d-flex'>
                      <div className='ml-auto d-flex'>
                        {/* <div className='app_lang d-flex'>
<span className='langCode'> {localStorage.getItem("lang") || "EN"} </span>
<span className='globalIcon my-auto ' onClick={changeLang}>
<RiGlobalLine title='Select Your Preferred Country & Language'  />
</span>  </div> */}
                        <div className='ml-auto d-flex header_profile'>
                          <span className="my-auto prof font-black"> {profileState.givenName + ' ' + profileState.familyName} </span>
                          {/*<BiUserCircle className='settings'/>*/}
                          <Profile />
                        </div>

                      </div>
                    </div>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions className='model-actions'>
                <Button className="cnbtn btn btn-outline-success" variant="outlined" onClick={changeLangClose}>
                  Cancel
                </Button>
                <Button className="sbtn btn btn-secondary right-space" variant="contained" color="success" onClick={selectLang}>
                  Select
                </Button>
              </DialogActions>
            </Dialog>




          </AppBar>
          {/* <Navbar className='nav-box-shadow'>
            <NavbarBrand className='d-flex justify-content-start'>
                <h5 style={{color: '#224880', fontWeight:'bold'}}>MyProject Workspace</h5>
            </NavbarBrand>
            <img className="d-inline-block align-top" src={emrlogo} width="auto" height="45" alt="emerson-logo"></img>
            <div className='d-flex'>
                <span className="my-2 prof"> {profileState.givenName+ ' '+ profileState.familyName} </span>
                <Profile logout={logout} />
            </div>
        </Navbar > */}
        </>
      }
      {/*ctrlState.showTags &&
          <ShowTags/>          
        */}
    </>
  )
}

export default NavBar;